// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Estado } from "../views/ViewGerenciarPropriedadeUsuario/interfaces/Estado";

export const estadoService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/estado`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        const estadosSystem = response.data.filter(
          (estado: Estado) => estado.origem === 0
        );
        return estadosSystem;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
